import { createApp, watch } from 'vue'
import App from './App.vue'
import router from './router/index.js';
import store from './store/index.js';
import i18n from './i18n';

document.documentElement.lang = i18n.global.locale.value;
document.title = i18n.global.t('app.title');
watch(i18n.global.locale, (locale) => {
    document.documentElement.lang = locale;
    document.title = i18n.global.t('app.title');
});

createApp(App)
    .use(router)
    .use(store)
    .use(i18n)
    .mount('#app')
